import { useContext, useEffect } from 'react';
import opacitySliderContext from '../../context/opacitySliderContext';

export const OpacityService = () => {
    const {setOpacity} = useContext(opacitySliderContext);


    const toggleOpacity = (visible: boolean) => {
        
        if (visible){
            const position = getPosition();
            setOpacity((prev: any) => ({ ...prev, visible: true, x: position.x, y: position.y}));
        }else{
            setOpacity((prev: any) => ({ ...prev, visible: false }));

        }
    }
    
    const getPosition = () => {
        let element = document.querySelector('#controls-map .opacity');
        if (element){
            const rect = element.getBoundingClientRect();
            return  {x:rect.top, y:rect.right};
        }
        return {x:0,y:0};
    }
    
    useEffect(() => {
        const handleResize = () => {
            const position = getPosition();
            setOpacity((prev: any) => ({ ...prev, x: position.x, y: position.y}));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    useEffect(() => {
        toggleOpacity(true);
        
        return () => {
            toggleOpacity(false);
        }
    }, []);
    return<></>
}
